document.querySelectorAll('.bento-customizing').forEach(function (root) {
  var grid = root.querySelector('[data-bento-grid]');
  var dots = Array.from(root.querySelectorAll('[data-bento-dot]'));
  var swipeHint = root.querySelector('[data-bento-swipe-hint]');
  if (!grid || !dots.length) return;

  var cards = Array.from(grid.querySelectorAll('.bento-card'));

  if (swipeHint) {
    var hideSwipeHint = function () {
      swipeHint.classList.add('is-hidden');
    };
    grid.addEventListener('scroll', hideSwipeHint, { once: true, passive: true });
    grid.addEventListener('touchstart', hideSwipeHint, { once: true, passive: true });
    setTimeout(hideSwipeHint, 4500);
  }

  function setActiveDot(index) {
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  function currentIndex() {
    var scrollLeft = grid.scrollLeft;
    var closest = 0;
    var closestDist = Infinity;
    cards.forEach(function (card, i) {
      var dist = Math.abs(card.offsetLeft - scrollLeft);
      if (dist < closestDist) {
        closestDist = dist;
        closest = i;
      }
    });
    return closest;
  }

  var ticking = false;
  grid.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        setActiveDot(currentIndex());
        ticking = false;
      });
    },
    { passive: true }
  );

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      var card = cards[i];
      if (!card) return;
      grid.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
    });
  });
});
